export const getSchedulesDoctorTranslationKey = (labelKey: string): string => {
  if (labelKey === 'LAB') return 'REPORT.TABLE.SCHEDULES_DOCTOR.LAB'
  return labelKey
}
